import {ensureLeadingSlash} from './ensureLeadingSlash';
import {ensureTrailingSlash} from './ensureTrailingSlash';

/**
 * @name ensureEncapsulatingSlashes
 */
export const ensureEncapsulatingSlashes = (url: string): string =>
  ensureTrailingSlash(ensureLeadingSlash(url));
